export default "__VITE_ASSET__d0268592__"